import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = {
  key: 0,
  class: "w-full h-full bg-primary rounded-full"
}
const _hoisted_3 = {
  key: 0,
  class: "w-full"
}

import { computed } from 'vue';
import { useUserStore } from '@/store/user';

export interface Choice {
  label: unknown;
  value: number | string | boolean;
  allowed: boolean;
}

interface Props {
  modelValue?: Choice['value'];
  choices?: Choice[];
  vertical?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    modelValue: { default: undefined },
    choices: { default: () => [] as Choice[] },
    vertical: { type: Boolean }
  },
  emits: ['update:modelValue'],
  setup(__props: any) {

const props = __props as { modelValue: Choice['value'], choices: Choice[], vertical?: boolean }

const user = useUserStore();




const isMetamaskInstalled = computed(() => {
  if (typeof window.ethereum !== 'undefined') {
    return true;
  } else {
    return false;
  }
});

const getKey = (value: Choice['value']) => {
  return typeof value === 'boolean'
    ? props.choices.findIndex((choice) => choice.value === props.modelValue)
    : value;
};

const isActive = (value: Choice['value']) => {
  return value === props.modelValue;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex", __props.vertical ? 'flex-col space-y-4' : 'space-x-4'])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.choices, ({ label, value, allowed }, index) => {
      return _withDirectives((_openBlock(), _createElementBlock("div", {
        key: getKey(value),
        class: _normalizeClass(["flex items-center flex-wrap px-4 py-3 border rounded cursor-pointer hover:border-primary-dark", {
        'border-primary': isActive(value),
        'order-last mt-4':
          _unref(user).me === null && _unref(isMetamaskInstalled) && value === 0,
      }]),
        onClick: ($event: any) => (_ctx.$emit('update:modelValue', value))
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["inline-block w-5 h-5 rounded-full border mr-3 p-0.5 flex-shrink-0", { 'border-primary': isActive(value) }])
        }, [
          (isActive(value))
            ? (_openBlock(), _createElementBlock("div", _hoisted_2))
            : _createCommentVNode("", true)
        ], 2),
        _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps({ label, value, index })), () => [
          _createElementVNode("span", {
            class: _normalizeClass({
            'text-primary': isActive(value),
            'text-gray-description': !isActive(value),
          })
          }, _toDisplayString(label), 3)
        ]),
        (isActive(value))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _renderSlot(_ctx.$slots, "content", _normalizeProps(_guardReactiveProps({ label, value, index })))
            ]))
          : _createCommentVNode("", true)
      ], 10, _hoisted_1)), [
        [_vShow, allowed]
      ])
    }), 128))
  ], 2))
}
}

})